// extracted by mini-css-extract-plugin
export default {"bg":"d692na","inlineContent":"MOJ0ni","pageWrapper":"bDumcJ","shadow":"o6Z4xx","leftBottom":"iuq89u","rightBottom":"VLsRS_","centerBottom":"BimZ_v","innerBg":"O0AsTI"};